import InputWithCopyButton from 'components/InputWithCopyButton/InputWithCopyButton';
import React from 'react';
import { STATE_LICENSE_API_NAMES, STATE_LABELS } from './state-license-helpers';
import propTypes from 'prop-types';
import style from './nonResidenceForm.module.scss';

function NonResidenceForm({ user = {} }) {
  return (
    <div className={style.nonResidenceForm}>
      {STATE_LICENSE_API_NAMES.map(api_name => {
        const licenseKey =
          api_name === 'Texas'
            ? `${api_name}_License_Informatio`
            : `${api_name}_License_Number`;

        return (
          <InputWithCopyButton
            key={api_name}
            label={STATE_LABELS[api_name]}
            value={user[licenseKey]}
            inLine
            lightLabel
            disabled
            noSpacing
            fixedWidth
          />
        );
      })}
    </div>
  );
}

NonResidenceForm.propTypes = {
  user: propTypes.object
};

export default NonResidenceForm;
